import colors from 'assets/styles/colors';
import UI from 'constants/ui';
import styled from 'styled-components';

export const AccordionStackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`;

export const AccordionWrapper = styled.div<{ $padding?: string }>`
  border: 1px solid ${colors.gray700};
  border-radius: ${UI.radius.md};
  padding: ${({ $padding }) => ($padding ? $padding : `0 ${UI.spacing.lg}`)};
`;

export const AccordionHeader = styled.button<{
  $disabled?: boolean;
  $canClick: boolean;
  $padding?: string;
}>`
  background: none;
  border: none;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: ${({ $padding }) => $padding};
  user-select: none;
  cursor: ${({ $canClick }) => ($canClick ? 'pointer' : 'default')};
  color: ${({ $disabled }) => ($disabled ? colors.gray500 : colors.white)};
`;

export const AccordionHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  line-height: 1.5rem;
  flex-grow: 1;
`;

export const ChevronWrapper = styled.div<{ open: boolean }>`
  width: 17px;
  height: 17px;
  transform: rotate(${({ open }) => (open ? '-180' : '0')}deg);
  transition: transform ${UI.duration.quick};
  margin-left: ${UI.spacing.xs};
`;

export const AccordionContent = styled.div<{ open: boolean }>`
  position: relative;
  border-top: 1px solid ${colors.gray700};
  padding: ${UI.spacing.lg} 0;
  width: 100%;

  display: ${({ open }) => (open ? 'block' : 'none')};
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
`;
